<script setup>
import commonService from '../service/common-service.js';
import logService from '../service/log-service.js';

const props = defineProps({
    faoModel: {
        type: Object
    },
    faoScreen : {
        type: String
    }
})

const emit = defineEmits(['callByLocation', 'callByLocationError']);

function searchOffices() {
    logService.eventLog("Find my nearest button clicked");
    commonService.getGeoLocation(pos => {
        if (pos != null) {
            emit('callByLocation', pos);
        }
    }, err => {
        if(err.code == err.TIMEOUT || err.code == err.UNKNOWN_ERROR){
            const errorData = { triggerMethod : "FindByLocation.searchOffices.geoLocationError", error : { code : err.code , message : err.message}};            
            logService.errorLog(JSON.stringify(errorData));
            window.location.href = window.location.hostname === "localhost" ? 
                "http://" + window.location.host + "/officelocator" : "https://" + window.location.hostname + "/officelocator";
        }
        var errorMessage = commonService.getFAOGeoLocationError(err, props.faoModel.geolocationDeniedErrorFAO)
        emit('callByLocationError', errorMessage);
    })
}
</script>

<template>
    <a 
        :id="'jh-find-my-nearest-' + faoScreen" 
        class="headerFAO-block__nearest" 
        v-html="faoModel.findMyNearestButton"
        tabindex="0"
        @click="searchOffices()"
        @keyup.enter="searchOffices()" 
        @keyup.space="searchOffices()" 
    >
    </a>
</template>

<style scoped>
.headerFAO-block__nearest {
    cursor: pointer;
    border-radius: 50px;
    border: 0;
    transition: all 0.1s ease-in-out;
    padding: 12px 20px;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -ms-user-select: none;
    user-select: none;
    font-size: 1em;
    line-height: 1em;
    font-family: OpenSans-SemiBold;
    text-decoration: none;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -ms-flex-direction: row;
        flex-direction: row;
    -ms-flex-align: center;
        align-items: center;
    white-space: nowrap;
    background-color: #360060;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.3);
    color: #FFFFFF !important;
    margin: 20px;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-pack: center;
        justify-content: center;
  }
  .headerFAO-block__nearest:hover,
  .headerFAO-block__nearest:active,
  .headerFAO-block__nearest:focus {
    transform-origin: center;
    transform: scale(1.1);
    text-decoration: none;
  }
  .headerFAO-block__nearest:hover,
  .headerFAO-block__nearest:active,
  .headerFAO-block__nearest:focus {
    color: #FFFFFF;
  }
  .headerFAO-block__nearest.ghost {
    background-color: transparent;
    box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.3);
    color: #360060;
    border: 2px #360060 solid;
  }
  .headerFAO-block__nearest.ghost:hover,
  .headerFAO-block__nearest.ghost:active,
  .headerFAO-block__nearest.ghost:focus {
    color: #360060;
  }

  @media (max-width: 991px) {
    .headerFAO-block__nearest:focus-visible {
      outline: none;
      box-shadow: 0 0 0 2px #222;
    }
  }
</style>